import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import { Button, makeStyles } from '@material-ui/core'



const CustomButton = props => {

  const data = useStaticQuery(graphql`
      {
        BUTTON_BACKGROUND_COLOR: setting(environmentName: {eq: "BUTTON_BACKGROUND_COLOR"}) {
            value
          }
          BUTTON_COLOR: setting(environmentName: {eq: "BUTTON_COLOR"}) {
          value
        }        
      }
    `)

  const BUTTON_BACKGROUND_COLOR = data.BUTTON_BACKGROUND_COLOR.value
  const BUTTON_COLOR = data.BUTTON_COLOR.value

  const useStyles = makeStyles({
    Button: {
      backgroundColor: `${BUTTON_BACKGROUND_COLOR}`,
      fontFamily: `${process.env.FONT_FAMILY}`,
      fontSize: `${process.env.FONT_SIZE}`,
      '&:hover': {
        backgroundColor: `${BUTTON_COLOR}`
      },
    }
  })

  const classes = useStyles()

  return (
    <Button className={classes.Button} size={props.size || "medium"} variant={props.variant || "contained"} color={props.color || "primary"} type={props.type || "submit"}>
      {props.children}
    </Button>
  )
}

export default CustomButton